export default function FriendRequestBanner({
  count = 1,
  className = "",
}) {
  if (!count) return null;
  return (
    <div
      className={`w-full rounded-xl p-4 sm:p-5 mb-4 sm:mb-6
                     bg-gradient-to-r from-[#1f2644] to-[#2a3157]
                     ring-1 ring-[#4F55F6]/30 shadow-[0_10px_30px_rgba(0,0,0,0.35)]
                     text-white ${className}`}
    >
      <div className="flex items-center gap-4 sm:gap-6">
        <div className="shrink-0 h-11 w-11 sm:h-12 sm:w-12 rounded-lg bg-[#4F55F6] grid place-items-center">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M16 11a4 4 0 1 0-4-4 4 4 0 0 0 4 4Z" fill="currentColor" />
            <path
              d="M7 12a3.5 3.5 0 1 0-3.5-3.5A3.5 3.5 0 0 0 7 12Z"
              fill="currentColor"
              opacity=".7"
            />
            <path
              d="M2 19.5c0-3.038 3.134-5 6.5-5s6.5 1.962 6.5 5v.5H2Z"
              fill="currentColor"
              opacity=".7"
            />
            <path
              d="M11 20h11v-.5c0-3.59-3.582-5.5-7-5.5-1.12 0-2.178.18-3 .49"
              fill="currentColor"
            />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-base sm:text-lg font-semibold tracking-wide">
            {count === 1
              ? "You have a friend request"
              : `You have ${count} friend requests`}
          </div>
          <div className="text-white/70 text-sm sm:text-base">
            Tap here to respond
          </div>
        </div>
        <a
          className="rounded-lg bg-[#4F55F6] hover:bg-[#3b41f3] px-4 py-2 sm:px-5 sm:py-2.5
                      text-sm sm:text-base font-bold text-white transition-colors"
        >
          View Requests
        </a>
      </div>
    </div>
  );
}
